__turbopack_context__.v({
  "className": "montserrat_6095e518-module__T9Xf3G__className",
});
